import { DiscountOfferTimer } from '@/components/DiscountOfferTimer/DiscountOfferTimer';
import { Profile } from '@/components/NewSidebar/components/Footer/Profile';
import { ViewPlansButton } from '@/components/NewSidebar/components/Footer/ViewPlansButton';
import styled from '@emotion/styled';
import { CreditsSideBarIndicator } from './CreditsSideBarIndicator';

const Container = styled.div`
    gap: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px;
`;

export const Footer = () => {
    return (
        <Container>
            <DiscountOfferTimer isExpanded={true} />

            <CreditsSideBarIndicator />

            <ViewPlansButton />

            <Profile />
        </Container>
    );
};
